import { Card, Form, Select } from "antd";
import React, { useEffect, useState } from "react";
import {
  collection,
  doc,
  getDocs,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../../firebase";
import { toast } from "react-hot-toast";

import FormAction from "../../../../components/common/FormAction";
import WarningMessage from "../../../../components/common/WarningMessage";

function Liability({ data }) {
  const [checked, setChecked] = useState(false);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));
      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const onCancel = () => {
    setChecked(false);
  };

  const handleFormSubmit = (values) => {
    Object.keys(values).forEach((field) => {
      if (values[field] === undefined) {
        values[field] = "";
      }
    });

    const status = {
      liabilityToLandlordInsurance: { status: values.status },
    };
    try {
      const tenantRef = doc(db, "companies", companyName, "tenants", data?.id);
      updateDoc(tenantRef, status);
      setChecked(false);
      toast.success("isnurance status updated successfully");
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    toast.error("There are problems with one or more required fields");
    console.log("Failed:", errorInfo);
  };

  const initialValues = {
    status: data?.liabilityToLandlordInsurance?.status,
  };
  return (
    <Card
      title="Liability to Landlord Insurance"
      extra={
        !checked ? (
          <span className="onclick-text" onClick={() => setChecked(true)}>
            Edit
          </span>
        ) : null
      }
    >
      {checked ? (
        <Form
          colon={false}
          labelCol={{ span: 8 }}
          onFinish={handleFormSubmit}
          onFinishFailed={onFinishFailed}
          initialValues={initialValues}
        >
          <Form.Item label="Status" name="status">
            <Select
              options={[{ value: "Enrolled" }, { value: "Not Enrolled" }]}
              defaultValue="Enrolled"
            />
          </Form.Item>
          <FormAction submit="submit" cancel={onCancel} />
        </Form>
      ) : (
        <Form colon={false} labelCol={{ span: 8 }}>
          <Form.Item label="Status">
            <p>
              {data?.liabilityToLandlordInsurance?.status
                ? data?.liabilityToLandlordInsurance?.status
                : "--"}
            </p>
          </Form.Item>
          <WarningMessage message="Tenant provided insurance has expired or has not been entered for some tenants." />
        </Form>
      )}
    </Card>
  );
}

export default Liability;
